<template>
  <div>
    <b-card>
      <div slot="header">
        <b-row>
          <b-col class="text-left">
            <strong v-text="$lang.reports" />
          </b-col>
          <b-col class="text-right">
            <b-button
              class="btn-lightgray ml-2"
              @click="settingModal = true"
              v-b-tooltip.hover
              :title="$lang.report_all_setting"
            >
              <mdicon name="cog-transfer-outline" />
            </b-button>
            <b-button
              class="btn-lightgray ml-2"
              v-b-tooltip.hover
              :title="$lang.report.rebuild"
              @click="showConfirm"
            >
              <mdicon name="recycle-variant" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row v-if="resource === 'azmoon_execute'">
        <b-col>
          <b-card>
            <div slot="header">
              <b-row>
                <b-col class="text-left">
                  <strong v-text="$lang.integrated_report" />
                </b-col>
                <b-col class="text-right">
                  <b-button
                    class="btn-lightgray ml-2"
                    v-b-tooltip.hover
                    :title="$lang.list_updating"
                    @click="getReportIntegrated"
                  >
                    <mdicon name="refresh" />
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="12" md="12" class="my-3">
                <LoadingSpinner :loading="isLoading" />
              </b-col>
              <b-col cols="12" md="12">
                <div
                  class="table-responsive mb-5"
                  v-if="!isLoading && itemGroups.length"
                >
                  <table
                    stickycolumn="true"
                    role="table"
                    class="washup-table table b-table table-bordered text-center table-hover align-middle"
                  >
                    <thead role="rowgroup" class="text-center">
                      <tr role="row">
                        <th class="empty position-relative p-3 text-center">
                          <span
                            class="text-competencies w-100"
                            v-text="$lang.report_name"
                          />
                        </th>
                        <th class="empty position-relative p-3 text-center">
                          <span
                            class="text-competencies w-100"
                            v-text="$lang.download_link"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(itemGroup, itemGroupIndex) in itemGroups"
                        :key="itemGroupIndex"
                      >
                        <td class="text-left text-dark">
                          <span class="ml-2" v-text="itemGroup.caption" />
                        </td>

                        <td class="text-center text-dark">
                          <span
                            @click="downloadFile(itemGroup.download_link)"
                            class="cursor_pointer text-primary"
                          >
                            <mdicon name="file-download-outline" size="20" />
                            <span v-text="$lang.received_file" class="ml-1" />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col v-if="!isLoading && !itemGroups.length" cols="12" md="12">
                <b-alert
                  show
                  variant="danger"
                  v-text="$lang.notExistParvandehInfoMessage"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mx-0 mt-3">
        <b-col>
          <SearchCard
            :filterCatch="true"
            :hasFilter="true"
            :title="$lang.reports"
            :url="url"
            :html="false"
            ref="reports"
            @updatePermissions="updateReportsPermissions"
            @getOther="updateOtherData"
            @getItems="updateReportItems"
          >
            <template slot="headerArea">
              <b-col
                v-if="reportItems.length"
                cols="12"
                md="12"
                class="bg-light my-3 py-2 rounded"
              >
                <b-row>
                  <b-col cols="12" md="6" class="py-1">
                    <b v-text="$lang.creator" />:
                    <span v-text="pathOr('', ['created_by'], otherData)" />
                  </b-col>
                  <b-col cols="12" md="6" class="py-1 text-right">
                    <b v-text="$lang.create_time" />:
                    <span
                      v-text="pathOr('', ['created_at', 'jalali'], otherData)"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="reportItems.length"
                cols="12"
                md="12"
                class="mb-3 px-0"
              >
                <b-alert :show="hasDownloadReport" variant="info">
                  <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="">
                      <i class="fas fa-info-circle fa-lg mr-2" />
                      <strong v-text="$lang.all_download_reports" />
                    </b-col>
                    <b-col cols="12" md="auto" class="text-center">
                      <b-button
                        class="m-1"
                        variant="success"
                        @click="downloadAllFiles()"
                      >
                        <mdicon name="cloud-download-outline" size="20" />
                        <span
                          v-text="$lang.received_all_reports"
                          class="ml-1"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-alert>
              </b-col>
            </template>
            <template slot="html" slot-scope="{ item }">
              <b-col cols="12" md="12" class="py-3">
                <b-row>
                  <b-col cols="12" md="2" class="text-center">
                    <b-img-lazy
                      fluid
                      thumbnail
                      :onerror="$config.images.onerrorDefaultImg"
                      :src="getAvatar(item)"
                      class="bg-white"
                      width="150"
                    />
                  </b-col>
                  <b-col cols="12" md="10">
                    <b-row>
                      <b-col cols="12" md="6" class="py-1">
                        <i class="far fa-check-circle mr-1" />
                        <b v-text="$lang.name_family" />:
                        <span
                          class="text-muted"
                          v-text="pathOr('', ['parvandeh', 'full_name'], item)"
                        />
                      </b-col>
                      <b-col cols="12" md="6" class="py-1">
                        <i class="far fa-check-circle mr-1" />
                        <b v-text="$lang.case_number" />:
                        <span
                          class="text-muted"
                          v-text="
                            pathOr('', ['parvandeh', 'parvandeh_number'], item)
                          "
                        />
                      </b-col>

                      <b-col
                        v-if="!!pathOr(false, ['report_caption'], item)"
                        cols="12"
                        md="6"
                        class="py-1"
                      >
                        <i class="far fa-check-circle mr-1" />
                        <b v-text="$lang.report_caption" />:
                        <span
                          class="text-muted"
                          v-text="pathOr('', ['report_caption'], item)"
                        />
                      </b-col>
                      <b-col cols="12" md="6" class="py-1">
                        <i class="far fa-check-circle mr-1" />
                        <b v-text="$lang.report_type" />:
                        <span
                          class="text-muted"
                          v-text="pathOr('', ['report_type'], item)"
                        />
                      </b-col>
                      <b-col cols="12" md="6" class="py-1">
                        <i class="far fa-check-circle mr-1" />
                        <b v-text="$lang.report_format" />:
                        <span
                          class="text-muted"
                          v-text="pathOr('', ['format'], item)"
                        />
                      </b-col>
                      <b-col
                        v-if="!pathOr(false, ['report_caption'], item)"
                        cols="12"
                        md="6"
                      />
                      <b-col cols="12" md="6" class="py-1 text-left">
                        <router-link
                          v-if="
                            item.request_type === 'service' &&
                            checkFrontPageName(item)
                          "
                          :to="generateReportRoute(item)"
                        >
                          <b-button class="m-1" variant="success">
                            <mdicon
                              v-if="item.format === 'xls'"
                              name="file-excel"
                              size="20"
                            />
                            <mdicon
                              v-if="item.format === 'html'"
                              name="language-html5"
                              size="20"
                            />
                            <mdicon
                              v-if="item.format === 'pdf'"
                              name="file-pdf-box"
                              size="20"
                            />
                            <span v-text="$lang.report_show" class="ml-1" />
                          </b-button>
                        </router-link>

                        <b-button
                          v-if="item.request_type === 'file'"
                          class="m-1"
                          variant="success"
                          @click="downloadFile(item.download_link)"
                        >
                          <mdicon name="cloud-download-outline" size="20" />
                          <span v-text="$lang.received_report" class="ml-1" />
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </template>
          </SearchCard>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="settingModal"
      variant="primary"
      header-bg-variant="primary"
      size="lg"
      content-class="border-primary"
      hide-header
      hide-footer
    >
      <div v-show="!settingCurrentItem">
        <Search
          :title="$lang.report_setting"
          :allowFields="$lang.report_setting_fields"
          :hiddenFields="[]"
          :url="reportSettingUrl"
          :visibleViewCount="false"
          :visibleSettings="false"
          :visibleAdd="false"
          :filterCatch="true"
          :showTotals="true"
          :defaultViewCount="10"
          :dynamicButtons="dynamicButtons"
          primaryKey="id"
          ref="search"
          @getPermisson="updatePermissions"
        />
        <b-row>
          <b-col cols="12" class="text-right pt-3">
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="settingModal = false"
            >
              {{ $lang.close }}
              <i class="fa fa-ban" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-card v-show="settingCurrentItem">
        <div slot="header">
          <strong v-text="$lang.report_setting" />
        </div>
        <LoadingSpinner
          :loading="settingLoading"
          :loadingText="$lang.sending_data"
        />
        <b-form v-if="!settingLoading">
          <b-form-group
            :label="$lang.report.introduction"
            label-for="introduction"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.report.settings.introduction"
              :rules="$v.introduction.$params"
            />
            <Editor dir="rtl" v-model="introduction" />
            <b-form-invalid-feedback
              :state="$v.introduction.$dirty ? !$v.introduction.$error : null"
            >
              <div v-if="!$v.introduction.required">
                {{
                  $lang.error_required
                    | replace($lang.report.settings.introduction)
                }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.report.display_name"
            label-for="display_name"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.report.settings.display_name"
              :rules="$v.display_name.$params"
            />

            <selectFind
              :options="displayNameOptions"
              v-model="$v.display_name.$model"
              label="text"
              id="value"
              :isValid="$v.display_name.$dirty ? !$v.display_name.$error : null"
            />

            <b-form-invalid-feedback id="display_name-feedback"
              >{{
                $lang.error_required
                  | replace($lang.report.settings.display_name)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.report.logo"
            label-for="logo"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.report.settings.logo"
              :rules="$v.logo.$params"
            />
            <selectFind
              :options="logoOptions"
              v-model="$v.logo.$model"
              label="text"
              id="value"
              :isValid="$v.logo.$dirty ? !$v.logo.$error : null"
            />

            <b-form-invalid-feedback id="logo-feedback"
              >{{ $lang.error_required | replace($lang.report.settings.logo) }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-row>
            <b-col cols="12" class="text-right pt-3">
              <b-button
                variant="success"
                @click="updateSetting"
                v-if="isAdmin(settingPermissions)"
              >
                {{ $lang.submitButton }}
                <i class="fa fa-check" />
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="settingCurrentItem = null"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban" />
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-modal>
    <Confirm
      v-model="confirmData.show"
      :title="confirmData.title"
      :description="confirmData.description"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="confirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      dynamicClass=""
      @ok="rebuildReport"
      @cancel="confirmData.show = false"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Editor from "@/components/ckeditor/editor";
import SearchCard from "@/components/base/searchCard";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, isAdmin, checkFrontPageName } from "@/shared/utils";

export default {
  name: "report-card",
  components: {
    Search,
    Editor,
    Confirm,
    LoadingSpinner,
    SearchCard,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
    reportIntegratedUrl: {
      type: String,
      default: null,
    },
    resource: {
      type: String,
      default: null,
    },
    code: {
      type: [String, Number],
      default: null,
    },
  },
  validations: {
    introduction: { required },
    display_name: {},
    logo: {},
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      itemGroups: [],
      logo: null,
      display_name: null,
      introduction: null,
      logoOptions: [
        {
          text: "رسا",
          value: "rasa",
        },
        {
          text: this.$lang.company,
          value: "company",
        },
      ],
      displayNameOptions: [
        {
          text: "نام کامل",
          value: "full_name",
        },
        {
          text: "کد",
          value: "internal_code",
        },
      ],
      settingList: [],
      settingCurrentItem: null,
      settingLoading: false,
      dynamicButtons: [
        {
          id: "0",
          name: "edit",
          click: this.showForm,
        },
      ],
      settingPermissions: [],
      confirmModal: false,
      settingModal: false,
      report_settings: null,
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.report_modalTitle,
        description: this.$lang.report_message,
      },
      reportsPermissions: [],
      otherData: null,
      reportItems: [],
    };
  },
  computed: {
    reportSettingUrl() {
      return generateApiUrl(["resources", "report_settings"], [], {
        resource: this.resource,
      });
    },
    hasDownloadReport() {
      return this.reportItems.some((item) => item.request_type === "file");
    },
  },
  created() {
    if (this.resource === "azmoon_execute") {
      this.getReportIntegrated();
    }
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    isAdmin,
    checkFrontPageName,
    showForm(item) {
      this.settingCurrentItem = item;
      this.logo = this.logoOptions.find(
        (x) => x.value === pathOr(null, ["setting", "logo"], item)
      );
      this.introduction = pathOr(null, ["setting", "introduction"], item);
      this.display_name = this.displayNameOptions.find(
        (x) => x.value === pathOr(null, ["setting", "display_name"], item)
      );
    },
    updatePermissions(data) {
      this.settingPermissions = data;
    },
    updateReportsPermissions(data) {
      this.reportsPermissions = data;
    },
    async rebuildReport() {
      try {
        this.confirmData.loading = true;
        const response = await this.$httpService.patch(this.url);
        this.$notify.success(response.data.message);
        this.confirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    showConfirm() {
      this.confirmData.show = true;
    },
    downloadFile(url) {
      if (!url) return;
      try {
        window.open(url, "_blank");
      } catch (error) {
        this.$generateError(error);
      }
    },
    downloadAllFiles() {
      const reports = this.reportItems.filter(
        (report) => report.request_type === "file"
      );
      const links = reports.map((item) => item.download_link);
      for (const link of links) {
        window.open(link, "_blank");
      }
    },
    async updateSetting() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.settingLoading = true;
        const id = pathOr(null, ["id"], this.settingCurrentItem);
        const url = generateApiUrl(["resources", "report_settings_id"], [id]);
        const payload = {
          settings: {
            introduction: this.introduction,
            logo: pathOr(null, ["value"], this.logo),
            display_name: pathOr(null, ["value"], this.display_name),
          },
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.showForm(null);
        this.settingModal = false;
        this.getReports();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.settingLoading = false;
      }
    },
    async getReportIntegrated() {
      try {
        this.isLoading = true;
        const response = await this.$httpService.get(this.reportIntegratedUrl);
        this.itemGroups = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    getAvatar(item) {
      const imgKind = pathOr([], ["parvandeh", "img_kind"], item);
      const imgItem = imgKind.find(
        (img) => pathOr(null, ["type"], img) === "thumb"
      );
      const address = pathOr(null, ["address"], imgItem);
      return address || this.$config.images.tinyLogo;
    },
    updateReportItems(data) {
      this.reportItems = data;
    },
    updateOtherData(data) {
      this.otherData = data;
    },
    generateReportRoute(item) {
      const isCenterExecute =
        pathOr(null, ["resource", "name"], item) === "center_execute";
      return {
        name: `${pathOr(null, ["front_page_name"], item)}-report`,
        params: {
          parvandehCode: pathOr(null, ["parvandeh", "code"], item),
          examPackId: pathOr(null, ["exam_pack", "id"], item), // use in azmoon module
          resourceCode: isCenterExecute
            ? this.code // for kanoon module
            : pathOr(null, ["azmoon_execute_person_code"], item), // for azmoon module
        },
      };
    },
  },
};
</script>
